import { render, staticRenderFns } from "./Blankpage.vue?vue&type=template&id=7799c13e"
import script from "./Blankpage.vue?vue&type=script&lang=js"
export * from "./Blankpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports